module.exports = __webpack_public_path__ + "img/expertise_imagebg.584f296d.png";